import { createContext, type ReactNode } from 'react';

/**
 * The node `EmptyValueDisplay` renders instead of its em dash. Emptiness is decided
 * inside each value display, not by the callers that render them, so the fallback
 * travels through context rather than a prop threaded through every display.
 *
 * `undefined` keeps the em dash; `null` renders nothing.
 *
 * A display that renders a nested display for a value it has already judged
 * non-empty must reset this context to `undefined` around that nested display —
 * otherwise the outer field's fallback leaks into inner values that happen to be
 * empty (see `ListValueDisplay`, `RelationValueDisplay`, `DynamicValueRenderer`).
 */
export const EmptyValueFallbackContext = createContext<ReactNode>(undefined);
